import React from 'react';
import styles from './StatusMessage.module.scss';
import { classnames } from '~/utils';

type StatusMessageProps = {
  children: React.ReactNode;
  status?: ActionStatus;
  icon?: React.ReactNode;
};

export default function StatusMessage({ children, status = 'success', icon }: StatusMessageProps) {
  return (
    <div className={classnames([styles.statusMessage, styles[status], icon && styles.hasIcon])}>
      {icon}
      {children}
    </div>
  );
}
